import { css } from "lit";
// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{line-height:1rem}.placement-no{color:inherit;font-size:.6rem;margin-bottom:.5rem;max-width:12rem;padding:0;width:100%}.placement-no:focus,.placement-no:hover{opacity:unset;-webkit-text-decoration:none;text-decoration:none}`, ""]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
